__turbopack_context__.v({
  "verified": "icons-module__ngm2nW__verified",
});
